export enum PortingContractHandling {
    TERMINATE_ON_END_DATE = 'Beëindig het huidige contract op de einddatum',
    ALREADY_TERMINATED = 'Het huidige contract is reeds beëindigd',
    TERMINATE_PREMATURELY = 'Beëindig het huidige contract voortijdig',
    DO_NOT_TERMINATE = 'Het Huidige contract niet beëindigen',
}

export namespace PortingContractHandling {
  export function tryFrom(value: string): string | null {
    const enumEntry = (Object.entries(PortingContractHandling) as [string, string][]).find(
      ([key, val]) => typeof val === 'string' && val === value
    );
    
    return enumEntry ? enumEntry[0] : null;
  }
}